// custom typefaces
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

// Azure Application Insights — privacy-safe telemetry (no PII, IP anonymized)
import { ApplicationInsights } from "@microsoft/applicationinsights-web"

const connectionString = process.env.GATSBY_APPINSIGHTS_CONNECTION_STRING

if (connectionString && typeof window !== "undefined") {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString,
      disableCookiesUsage: true,         // no tracking cookies
      isStorageUseDisabled: true,        // no localStorage tracking
      disableAjaxTracking: true,         // only track page views, not API calls
      enableAutoRouteTracking: true,     // track SPA page navigations
      disableIpMasking: false,           // Azure anonymizes IP by default
    },
  })
  appInsights.loadAppInsights()
  appInsights.trackPageView()
}

// Render Mermaid diagrams in blog posts
export const onRouteUpdate = async () => {
  if (typeof document === "undefined") return

  const codeBlocks = Array.from(
    document.querySelectorAll("pre code.language-mermaid")
  )
  if (codeBlocks.length === 0) return

  const { default: mermaid } = await import("mermaid")
  mermaid.initialize({ startOnLoad: false, theme: "default" })

  for (const [index, codeBlock] of codeBlocks.entries()) {
    const graphDefinition = codeBlock.textContent
    const pre = codeBlock.parentElement
    try {
      const { svg } = await mermaid.render(
        `mermaid-diagram-${index}`,
        graphDefinition
      )
      const div = document.createElement("div")
      div.className = "mermaid-container"
      div.innerHTML = svg
      pre.parentElement.replaceChild(div, pre)
    } catch (err) {
      console.error("Mermaid render error:", err)
    }
  }
}
